/**
 * Syncs the "Delivery:" cart property for items added via third-party upsell apps
 * (e.g. Essential Upsell). Essential Preorder sets "Note: Pre-order" via its
 * selling plan, but injects "Delivery:" only on the native product page add-to-cart.
 * This script fills that gap.
 */
(function () {
  const DELIVERY_KEY = 'Delivery';
  const cache = new Map();
  let syncing = false;

  async function getDeliveryMessages(handle) {
    if (cache.has(handle)) return cache.get(handle);
    try {
      const html = await fetch(`/products/${handle}`).then((r) => r.text());
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const el = doc.querySelector('[id^="IncomingBadgeMessages"]');
      const data = el ? JSON.parse(el.textContent) : {};
      cache.set(handle, data);
      return data;
    } catch {
      cache.set(handle, {});
      return {};
    }
  }

  async function syncDeliveryProperties() {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      let didUpdate = false;

      for (const item of cart.items) {
        if (!item.selling_plan_allocation) continue;

        const props = item.properties || {};
        if (Object.prototype.hasOwnProperty.call(props, DELIVERY_KEY)) continue;

        const messages = await getDeliveryMessages(item.handle);
        const deliveryMsg = messages[String(item.variant_id)];
        if (!deliveryMsg) continue;

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            properties: { ...props, [DELIVERY_KEY]: deliveryMsg },
          }),
        });
        didUpdate = true;
      }

      if (didUpdate) {
        // Trigger cart re-render in Tinker theme
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } finally {
      syncing = false;
    }
  }

  // Intercept fetch to detect any /cart/add.js calls (from any app)
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await _fetch.apply(this, args);
    const url = (typeof args[0] === 'string' ? args[0] : args[0]?.url) || '';
    if (url.includes('/cart/add') || url.includes('cart/add.js')) {
      setTimeout(syncDeliveryProperties, 800);
    }
    return response;
  };

  // Also run on page load (covers items already in cart)
  document.addEventListener('DOMContentLoaded', syncDeliveryProperties);
})();
